module.exports = __webpack_public_path__ + "static/media/chicao.2a5ac992.jpeg";